import eventTypeGroups from './eventTypeGroups';

import type { EventLogTypeGroup } from 'shared-types';

interface Params {
  type: EventLogTypeGroup;
}

const entries: [string, readonly string[]][] = Object.entries(eventTypeGroups);

const eventTypesByGroup = entries.reduce<Record<string, string[]>>(
  (eventTypes, [eventType, groups]) => {
    groups.forEach((group) => {
      eventTypes[group] = [...(eventTypes[group] || []), eventType];
    });

    return eventTypes;
  },
  {}
);

/**
 * Event types belonging to a single type group, prefixed with the 'all' option
 * used by the event log type filter.
 */
const getLimitedEventsByTypeGroup = ({ type }: Params): string[] => {
  const eventTypes = eventTypesByGroup[type];
  return eventTypes ? ['all', ...eventTypes] : [];
};

export default getLimitedEventsByTypeGroup;
